
import React from 'react'
import { GridNoRecords, Grid, GridColumn as Column } from '@progress/kendo-react-grid'
import { useTranslation } from "react-i18next"
import './questionsPure.css'
import { useMediaQuery } from '@material-ui/core';
const TooltipContentTemplate = (props) => {
  return (
    <a>
      <p>{props.content}</p>
    </a>
  );
};


export default function QuestionsPure({ signers, changeRows, changeRowsLeftRigth, toggleDeleteQuestion, type, toggleEditQuestion
}) {
  const { t } = useTranslation()

  const longmatches = useMediaQuery("(max-width:960px)");

  const gridLabelNorecordsStyles = {
    color: '#828282',
    fontSize: '15px',
    fontWeight: 500
  }

  return (
    <React.Fragment>
      <Grid
        className='sequential-signer-name'
        resizable
        // reorderable
        data={signers}
      >
        {/* <Column title="" cell={DragCell} width='auto' /> */}
        <Column field='consecutive' headerClassName='questionsPure-column-1' className='questionsPure-column-1' title={t("digitalContractDashboard.manageQuestion.order")} />
        <Column field='question' headerClassName='questionsPure-column-2' className='questionsPure-column-2' title={t("digitalContractDashboard.manageQuestion.questionName")} />
        <Column title={t("digitalContractDashboard.manageQuestion.actions")} headerClassName='questionsPure-column-3' cell={(params) => (
          <td className='questionsPure-column-3'>
            <div className='questionsPure-action-cell-sequential' >
              <div className='questionsPure-arrow-up'>
                <i style={{ cursor: 'pointer' }} class='material-icons md-24' onClick={() => changeRows(params.dataItem, -1)}  >keyboard_arrow_up </i>
              </div>
              <div className='questionsPure-arrow-down'>
                <i style={{ cursor: 'pointer' }} class='material-icons md-24' onClick={() => changeRows(params.dataItem, 1)}  >keyboard_arrow_down </i>
              </div>
              <div className='questionsPure-arrow-right'>
                <i style={{ cursor: 'pointer' }} class='material-icons md-24' onClick={() => changeRowsLeftRigth(params.dataItem, -1)}  >keyboard_arrow_left </i>
              </div>
              <div className='questionsPure-arrow-left'>
                <i style={{ cursor: 'pointer' }} class='material-icons md-24' onClick={() => changeRowsLeftRigth(params.dataItem, 1)}  >keyboard_arrow_right </i>
              </div>
              <div className='questionsPure-container-btns'>
                <div className={"questionsPure-cellActions-containerBtnsDetails"}>
                  <button
                    className="questionsPure-cellActions-btn"
                    onClick={() => toggleDeleteQuestion(params.dataItem)}
                    data-id={t("questionnairesAdministrationView.header.title.delete.question")}
                  >
                    <p className="cellActions-textBotton">{longmatches ? t("questionnairesAdministrationView.header.title.delete") : t("questionnairesAdministrationView.header.title.delete.question")}</p>
                  </button>
                </div>
                <div className={"questionsPure-cellActions-containerBtnsDetails"}>
                  <button
                    className="questionsPure-cellActions-btn "
                    onClick={() => toggleEditQuestion(params.dataItem)}
                    data-id={t("questionnairesAdministrationEditDetailView.btn.edit.question")}
                  >
                    <p className="cellActions-textBotton">{longmatches ? t("questionnairesAdministrationEditDetailView.btn.edit") : t("questionnairesAdministrationEditDetailView.btn.edit.question")}</p>
                  </button>
                </div>
              </div>

            </div>
            <div
              className="questionsPure-cellActions-mobileExpanded"
              onClick={() => toggleEditQuestion(params.dataItem)}
              data-id={t("questionnairesAdministrationEditDetailView.btn.edit.question")}
            >
              {">"}
            </div>
          </td>
        )} />
        <GridNoRecords>
          <p style={gridLabelNorecordsStyles} >
            {t(type === 'validators' ? 'signatoryList2.notAddValidators' : 'signatoryList2.notAddSigners')}
          </p>
        </GridNoRecords>
      </Grid>
    </React.Fragment>
  );
}